/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AdminApp } from "./AdminApp";
import { PortfolioPage } from "./PortfolioPage";
import { AdsPage } from "./AdsPage";
import { normalisePath } from "./lib/site";

/**
 * Minimal path-based routing. Each surface is an independent full-page app, so
 * a router library would be more machinery than this needs — the URL alone
 * decides what renders.
 *
 * On Cloudflare Pages the `_redirects` rule sends any non-file path to the app
 * shell, so `/admin`, `/art` and `/ad` are all requested directly rather than
 * routed client-side.
 */
function Root() {
  switch (normalisePath(window.location.pathname)) {
    case "/admin":
      return <AdminApp />;
    case "/art":
      return <PortfolioPage />;
    case "/ad":
      return <AdsPage />;
    default:
      return <App />;
  }
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <Root />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
